// Lazy contentful client. The `contentful` SDK drags in ~500KB of crypto
// polyfills (elliptic, asn1.js, diffie-hellman, etc). It used to be imported
// eagerly through the root reducer (slices/posts + slices/content), forcing
// that payload onto every page. We now dynamically import the SDK only the
// first time a contentful query actually runs (blog / CMS content), keeping it
// out of the initial bundle.
let clientPromise;

const getClient = () => {
  if (!clientPromise) {
    clientPromise = import(/* webpackChunkName: "contentful" */ 'contentful').then(
      ({ createClient }) =>
        createClient({
          space: '61geg9wy6l6n',
          accessToken: '-29k3bLRf639nFplqwJnOUJvkJo9yZYS1jzrslij_qk',
        })
    );
  }
  return clientPromise;
};

const client = {
  getEntries: async (...args) => (await getClient()).getEntries(...args),
  getEntry: async (...args) => (await getClient()).getEntry(...args),
  getAsset: async (...args) => (await getClient()).getAsset(...args),
};

export default client;
